<section class="columns mt-2">
  <div class="column mx-2 box">
    <p class="is-size-9 weight-medium mb-2">
      {{ 'itinerary-info.flight.original' | translate }}
    </p>
    <div class="mb-2" *ngFor="let flight of rescheduledOriginalFlights">
      <app-card-flight [cleanColor]="true" [flight]="flight"></app-card-flight>
    </div>
  </div>
  <div class="column mx-2 box">
    <p class="is-size-9 weight-medium mb-2">{{ 'itinerary-info.flight.new' | translate }}</p>
    <div *ngFor="let flight of rescheduledRecommendationFlights" class="mb-2">
      <app-card-flight [cleanColor]="true" [flight]="flight"></app-card-flight>
    </div>
  </div>
</section>
